import * as React from "react";
import * as request from "superagent";
import * as path from "path";
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap,
} from "@material-ui/core/styles/withStyles";

import { Definition } from "~common/lib/types";
import { APIError } from "~common/lib/types";
import URLManager from "~common/lib/url-manager";
import { Theme } from "@material-ui/core/styles";
import ContentScroller from "./content-scroller";

import LoadingView from "~common/components/loading-view";

import {
  Checkbox,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography
} from "@material-ui/core";

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  modalContent: {
    minHeight: 300,
    width: 570,
  },
  modal: {
    minHeight: 300,
    minWidth: 600,
  },
  fieldLabel: {
  },
  predefinedCheckbox: {
    padding: 5
  },
  fieldLabelDisabled: {
    color: theme.palette.grey[500]
  },
  definitions:{
    paddingLeft: 10
  },
  predefined:{
    paddingLeft: 10
  },
  multiIndicator:{
    fontSize: "0.5em",
    verticalAlign: "super",
    marginLeft: 5
  }

});

interface Props extends React.HTMLProps<HTMLDivElement> {
  definition?: any;
  rootPath?: string;
  dimensions?: Array<any>;
  maxDimensions?: number; 
  onSelectionChange?: (definition: any, rootPath: string | undefined, item: any, checked: boolean) => void;
  suppressTitle?: boolean;
}

type State = {
  status: "loading" | "ready" | "error";
  selected?: Array<any>;
  error?: any;
};

class DefinitionFieldSelector extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "loading",
      selected: [],
    };
  }


  isItemSelected(item:any):boolean {
    return false;
  }

  handleCheckboxChange = (item:any) => (evt:any) => {
    const { definition, rootPath } = this.props;  

    item.selected = evt.target.checked;
    if(this.props.onSelectionChange){
      this.props.onSelectionChange(definition, rootPath, item, evt.target.checked)
    } 
    this.forceUpdate()
  }


  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { definition, rootPath, dimensions, maxDimensions } = this.props;
    const { status } = this.state;

    var workingDefinition = new Definition(definition);

    var predefined: any = null
    var hasPredefined: boolean = false;
    if (workingDefinition && workingDefinition.predefined) {
      predefined = workingDefinition.predefined.map((item: any) => {
        if(item.allowExtraction) {
          var fieldPath: string = path.join(rootPath || "", item.path || item.key)
          var isDisabled:boolean = false;
          var labelClass: string = classes.fieldLabel;
          if (definition.allowsMultiples && dimensions && maxDimensions && dimensions.length >= maxDimensions) { 
            // We have the maximum number of dimesions, but if this item is part of a selected dimension, let it through.


            const holdingDim = dimensions.find((dimPath, idx) => {
              if ((fieldPath||"").indexOf(dimPath) == 0) {
                return true;
              }
            })
            if (!holdingDim) {
                isDisabled = true;
                labelClass = classes.fieldLabelDisabled;
            }
          }

          return (
            <div>
              <Checkbox disabled={isDisabled} className={classes.predefinedCheckbox} value={item.selected} onChange={this.handleCheckboxChange(item)} inputProps={{ 'aria-label': 'primary checkbox' }} />
              <span className={labelClass}>{item.title} </span>
            </div>
          )
        }
        return null
      })
    }

    var subDefs: any = null
    
    var hasSubDefs: boolean = false;

    if (workingDefinition && workingDefinition.definitions) {
      // See if the definition has subdefinitions containing fields that can be extracted.
      if (workingDefinition.hasExtractableFields()) {
        hasSubDefs = true;
        // If so, we should show this and set the flag
        subDefs = workingDefinition.definitions.map((d: any) => {
          var defPath: string = path.join(rootPath || "", d.path || d.key)
          const dfs = <DefinitionFieldSelectorWS definition={d} rootPath={defPath} onSelectionChange={this.props.onSelectionChange} dimensions={dimensions} maxDimensions={maxDimensions} />
          return (
            <div>
              {dfs}
            </div>
          )
        })

      }
    }

    if (!hasPredefined && !hasSubDefs) {
      // basically make this one invisible.
      return null
    }

    var title: any = null;
    if(!this.props.suppressTitle) {
        var multiIndicator: any = null;
        if (workingDefinition && workingDefinition.allowsMultiples) {
          multiIndicator = <i className={"fa fa-infinity " + classes.multiIndicator} aria-hidden="true"></i>
        } 
        title = (
          <Typography variant="h6" >{definition.title}{multiIndicator}</Typography>
        )
    }

    return (
      <div key={definition.key}>
        {title}
        <div>
          <div className={classes.predefined} >{predefined}</div>
          <div className={classes.definitions}>{subDefs}</div>
        </div>
      </div>
    );

  }
}

const DefinitionFieldSelectorWS = withStyles(styles)(DefinitionFieldSelector);

export default DefinitionFieldSelectorWS; 
